var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders;
  return {
    columnPadding: spacing.xSmall,
    sidebarIsOpenBottomBorderColor: colors.contrasts.grey4570,
    sidebarIsOpenBottomBorderWidth: borders.widthSmall
  };
};
export default generateComponentTheme;